/** 00:00〜23:30 の30分刻みの時刻（HH:mm）。日時の絞り込みの時刻欄（操作ログ検索・予約タスクの絞り込み）の選択肢 */
export const HALF_HOUR_TIME_OPTIONS: string[] = Array.from({ length: 48 }, (_, index) => {
  const hour = String(Math.floor(index / 2)).padStart(2, '0')
  const minute = index % 2 === 0 ? '00' : '30'
  return `${hour}:${minute}`
})
